import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"


const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const restoreSubCategoryAction = createAsyncThunk(
    'restore-sub-category',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.patch(`/admins/api/restore-sub-category`, { ...data })
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const restoreSubCategorySlice = createSlice({
    name: 'restore-sub-category',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(restoreSubCategoryAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(restoreSubCategoryAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(restoreSubCategoryAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const restoreSubCategoryReducer = restoreSubCategorySlice.reducer    